import { LanguageEnum } from '../enums';

export interface RegisterCustomerData {
  companyName: string;
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  password: string;
  qrCodeId: string;
  language: LanguageEnum;
}

export namespace RegisterCustomerData {
  export function mapToApiValue({ language, ...restOfData }: RegisterCustomerData): any {
    return {
      ...restOfData,
      language: LanguageEnum.mapToApiValue(language),
    };
  }
}
